export const thfPageBlockedUserLiterals = {
  none: {
    pt: {
      title: 'Opa!',
      firstPhrase: 'Tivemos que bloquear essa tela temporariamente.',
      secondPhrase: 'Mas nÃ£o se preocupe! Basta fazer seu login novamente.'
    },
    en: {
      title: 'Oops!',
      firstPhrase: 'We had to temporarily block this screen.',
      secondPhrase: 'But do not worry! Just sign in again.'
    },
    es: {
      title: 'Opa!',
      firstPhrase: 'Tuvimos que bloquear esta pantalla temporalmente.',
      secondPhrase: 'Â¡Pero no se preocupe! SÃ³lo tienes que iniciar sesiÃ³n de nuevo.'
    },
  },
  exceededAttempts: {
    pt: {
      title:
        'Opa!',
      firstPhrase:
        `Para sua seguranÃ§a, apÃ³s {0} tentativa(s) de senha seu usuÃ¡rio fica bloqueado e nÃ£o pode ser acessado em {1} hora(s) :( `,
      secondPhrase:
        'Isso Ã© para evitar que hackers invadam sua conta.',
      thirdPhrase:
        'Mas nÃ£o se preocupe! Se vocÃª for o dono da conta e apenas esqueceu sua senha, basta entrar em contato com o suporte.'
    },
    en: {
      title:
        'Oops!',
      firstPhrase:
        `For your security, after {0} attempt(s) of password
        your user gets blocked and can not be accessed in {1} hour(s) :(`,
      secondPhrase:
        'This is to prevent hackers from hacking into your account.',
      thirdPhrase:
        'But do not worry! If you are the owner of the account and just forgot your password, just contact support.'
    },
    es: {
      title:
        'Opa!',
      firstPhrase:
        `Para su seguridad, despuÃ©s de {0} intento(s) de contraseÃ±a
        su usuario queda bloqueado y no puede ser accedido en {1} hora(s) :(`,
      secondPhrase:
        'Esto es para evitar que los hackers invadan su cuenta.',
      thirdPhrase:
        `Â¡Pero no se preocupe! Si usted es el dueÃ±o de la cuenta
        y acaba de olvidar su contraseÃ±a, simplemente pÃ³ngase en contacto con el soporte.`
    }
  },
  expiredPassword: {
    pt: {
      title:
        'Opa! Sua senha expirou',
      firstPhrase:
        `A cada {0} dia(s) Ã© preciso criar uma nova senha por questÃ£o de seguranÃ§a. ApÃ³s esses {0} dia(s) seu acesso Ã© bloqueado :(`,
      secondPhrase:
        'Mas nÃ£o se preocupe! Basta entrar em contato com o administrador do sistema.'
    },
    en: {
      title:
        'Oops! Your Password has expired',
      firstPhrase:
        `Every {0} day(s) you need to create a new password for security reasons.
        After these {0} day(s) your access is blocked :(`,
      secondPhrase:
        'But do not worry! Just contact your system administrator.'
    },
    es: {
      title:
        'Opa! Su contraseÃ±a ha caducado',
      firstPhrase:
        `Cada {0} dÃ­a(s) es necesario crear una nueva contraseÃ±a por razones de seguridad.
        DespuÃ©s de estos {0} dÃ­a(s) su acceso estÃ¡ bloqueado :(`,
      secondPhrase:
        'Â¡Pero no se preocupe! SÃ³lo tienes que ponerse en contacto con el administrador del sistema.'
    }
  }
};
